import { createContext, useContext } from 'react';

/**
 * Uygulamanın ek dosyalarına erişimi (ortak 2026-10-24 madde 4; ADR 0126). Ekranlar ekin
 * adresini kaynaklarından (`attachmentUrl`, `fileUrl`) verebilir; vermezlerse bu bağlam
 * kullanılır. Gemi uygulaması kökte verir: adres `felix-file://attachment/<id>` (ana süreç gemi
 * sunucusunun ek ucuna gider; internet gerekmez), indirme kaydetme penceresiyle. Web ofiste
 * kaynaklar adresi zaten verir.
 */
export interface AttachmentFiles {
  /** Ekin okunabilir adresi; yetki indirme ucunun yetkisidir. */
  url(attachmentId: string): string;
  /**
   * İndirme (gemi: kaydetme penceresi). Verilmezse adres indirme bağlantısı olur. Vazgeçme
   * hata değildir; kaydedilemezse kodlu hata fırlatır.
   */
  save?(file: { id: string; fileName: string }): Promise<void>;
}

export const AttachmentFilesContext = createContext<AttachmentFiles | null>(null);

export function useAttachmentFiles(): AttachmentFiles | null {
  return useContext(AttachmentFilesContext);
}
